import { render, staticRenderFns } from "./RevokeSignModal.vue?vue&type=template&id=5e85fac2&"
import script from "./RevokeSignModal.vue?vue&type=script&lang=ts&"
export * from "./RevokeSignModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports